import { get as apiGet } from 'api'

export const getAll = async request => apiGet('/unimportedInvoices/getlist', request)

export const get = async id => apiGet(`/unimportedInvoices/${id}`)

export const getCount = async () => apiGet(`/unimportedInvoices/getCount`)
